import React from 'react'
import ME from '../../assets/about_victor.png'
import './about.css'
import { FaAward } from 'react-icons/fa'
import { FiUsers } from 'react-icons/fi'
import { VscFolderLibrary } from 'react-icons/vsc'

const About = () => {
  return (
    // <div>About</div>
    <section id='about'>
      <h5> Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about_me-image">
            <img src={ME} alt="" />
          </div> 
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className='about__card' >
              <FaAward className='about__icon' />
              <h5>Experience</h5>
              <small>3+ years Working</small>
            </article>

            <article className='about__card' >
              <FiUsers className='about__icon' />
              <h5>Clients</h5>
              <small>15+ Worldwide</small>
            </article>

            <article className='about__card' >
              <VscFolderLibrary className='about__icon' />
              <h5>Projects</h5>
              <small>10+</small>
            </article>

          </div>
          <p>
          I am a software engineer based in Lagos, Nigeria, I build mobile applications with fluid designs, Leveraging on Flutter and Dart. I love to solve problems. Please feel free to reach out to me. I look forward to hearing from you
          </p>

          <a href="#contact" className='btn btn-primary'>Let's Talk</a>
        </div>
      </div>
    </section>
  )
}

export default About